import ImageCarousel from "../Components/ImageGallery.tsx";
import { Helmet } from 'react-helmet-async';

export const AboutUs = () => {
    return (
        <>
            <Helmet>
                <title>O nas | Biuro rachunkowe Saldo.pl | 15 lat doświadczenia</title>
                <meta name="description" content="Poznaj biuro rachunkowe Saldo.pl - zespół doświadczonych księgowych z ponad 15-letnim doświadczeniem. Obsługujemy firmy z różnych branż, dostosowując się do indywidualnych potrzeb klientów." />
                <meta name="keywords" content="o nas biuro rachunkowe, doświadczeni księgowi, historia biura rachunkowego, zespół księgowych, biuro rachunkowe Cieszyn" />
                <link rel="canonical" href="https://podatki-saldo.pl/about" />
                <meta property="og:title" content="O nas | Poznaj zespół biura rachunkowego Saldo.pl" />
                <meta property="og:description" content="Zespół doświadczonych księgowych z 15-letnim doświadczeniem. Poznaj nas i dowiedz się, dlaczego warto z nami współpracować." />
                <meta property="og:url" content="https://podatki-saldo.pl/about" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="main-content">
                <div className="aboutus">
                    <div className="white-section">
                        <ImageCarousel></ImageCarousel>
                    </div>
                    <div className="dark-section">
                        <div className="aboutus-section">
                        <h2>Dlaczego warto z nami pracować?</h2>
                        <div className="aboutus-section-grid">
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-1.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3> Dostosowujemy się do Twojego biznesu</h3>
                                    Mamy klientów z różnych branż – od deweloperów i producentów, po firmy handlowe,
                                    transportowe czy kancelarie prawne. Dzięki temu rozumiemy specyfikę różnych działalności i
                                        potrafimy dopasować się do indywidualnych potrzeb.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-2.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3>Mamy doświadczenie, które procentuje</h3>
                                    Piętnaście lat na rynku to nie przypadek. Zatrudniamy specjalistów, którzy znają księgowość
                                    i podatki od podszewki. Możesz mieć pewność, że Twoje sprawy są w dobrych rękach.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-3.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3>Stawiamy na bezpieczeństwo</h3>
                                    Korzystamy z nowoczesnych systemów księgowych i dbamy o ochronę danych. Mamy ubezpieczenie
                                    OC na kwotę 500.000 zł, ale dzięki naszej skrupulatności nigdy nie musieliśmy z niego
                                    korzystać.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-4.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3>Jesteśmy Twoim partnerem w biznesie</h3>
                                    Nie ograniczamy się do „papierologii”. Analizujemy sytuację finansową firm, wskazujemy
                                    korzystne rozwiązania i wspieramy w podejmowaniu kluczowych decyzji. Reprezentujemy klientów
                                    przed urzędami, dbając o to, by wszystko było dopięte na ostatni guzik.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-5.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3> Korzystamy z nowoczesnych narzędzi</h3>
                                    Automatyzacja i cyfryzacja to dla nas standard. Pracujemy na najnowszych wersjach
                                    oprogramowania Symfonia, współpracujemy z Saldeo Smart i wFirma. Nasza infrastruktura IT
                                    zapewnia szybkie i wygodne zarządzanie dokumentacją.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-6.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3>Ty wybierasz, jak pracujemy</h3>
                                    Dostosowujemy się do Twojego stylu pracy – dokumenty możesz dostarczyć osobiście, pocztą,
                                    kurierem lub przez system online.
                                </div>
                            </div>
                            <div className="aboutus-grid-item">
                                <img className="exposed-number" src="/icons/circle-7.png" width="50" height="50"/>
                                <div className="aboutus-section-grid-item-text">
                                    <h3>Współpraca z nami to przyjemność</h3>
                                    Stawiamy na dobrą atmosferę – zarówno wewnątrz zespołu, jak i w relacjach z klientami.
                                    Życzliwość, optymizm i profesjonalizm to nasze standardy.
                                    Razem znajdziemy najlepsze rozwiązania!
                                    Księgowość nie musi być skomplikowana – z nami będzie prosta i przejrzysta. Skontaktuj się z
                                    nami, a pokażemy Ci, jak możemy pomóc Twojej firmie działać jeszcze lepiej!
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>

                </div>
            </div>
        </>
    )
}